<template>
  <button class="icon-button" @click="toggleModal">
    <div class="tooltipContainer">
      <div class="icon-help" :style="transparentColor">
        <IconBase iconColor="#111" viewBox="0 0 90 90" width="100%" height="100%" strokeWidth="0px"><IconHelp /> </IconBase>
      </div>
      <div class="tooltipElement chatTooltip">
        <span class="tooltipTip">Report</span>
        <span class="tooltipShortcut">ALT+R</span>
      </div>
    </div>
  </button>
</template>

<script>
import IconBase from "../../../../../components/IconBase";
import IconHelp from "../../../../../components/SVG/IconHelp";
import { transparentColor } from "../../SessionHelpers/colors";

export default {
  name: "HelpToggle",
  components: {
    IconBase,
    IconHelp,
  },
  computed: {
    transparentColor() {
      return transparentColor();
    },
  },
  methods: {
    toggleModal() {
      this.$store.dispatch("modals/toggleState", "reportModal");
    },
  },
};
</script>

<style>
@import "../../SessionStyles/Tooltip.css";
.icon-button {
  position: relative;
  margin-right: 6px;
  padding: 0px;
  margin: 0px 4px;
}
.icon-help {
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 360px;
  background-color: rgba(255, 255, 255, 0.65);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  padding: 10px;
  padding-right: 7.5px;
  padding-left: 12.5px;
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 69% / 40%);
}
.chatTooltip {
  top: 52px;
  bottom: 0;
  margin-left: 34px;
  margin-right: 34px;
}
</style>
